import { render, staticRenderFns } from "./SamplesTableActionRenderer.vue?vue&type=template&id=1721b4d2&"
import script from "./SamplesTableActionRenderer.vue?vue&type=script&lang=ts&"
export * from "./SamplesTableActionRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./SamplesTableActionRenderer.vue?vue&type=style&index=0&id=1721b4d2&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports